import { Sticker } from './../../models/Sticker';
import { ProjectService } from './../../services/project.service';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Project } from '@model/Project';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Message } from '@model/Message';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-project-status',
  templateUrl: './modal-project-status.component.html',
  styleUrls: ['./modal-project-status.component.scss']
})
export class ModalProjectStatusComponent implements OnInit {

  @Input() public project: Project = {} as Project;

  stiker: Sticker = {} as Sticker;
  projectForm: FormGroup;
  submitted: boolean = false;
  projectSave: Project;

  status: any = [
    { value: 'development', description: 'Em desenvolvimento' },
    { value: 'presenting', description: 'Apresentação' },
    { value: 'subject', description: 'Submetido' },
    { value: 'published', description: 'Publicado' },
  ];

  presenting: any = [
    { value: 'qualification', description: 'Qualificação/TCC1' },
    { value: 'vindication', description: 'Defesa/TCC2' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private projectService: ProjectService,
    private toast: ToastrService
  ) { }

  ngOnInit() {
    console.log(this.stiker);
    this.projectForm = this.formBuilder.group({
      status: [this.project.status],
      magazine: [this.stiker.magazine],
      each_day: [this.stiker.each_day],
      description: [this.stiker.description]
    });

    if ((!this.project.presenting_status || this.project.presenting_status === undefined) && this.project.status == 'presenting') {
      this.project.presenting_status = 'qualification';
    }
    
    if (this.project.published_date) {
      const published = moment(this.project.published_date, 'MM-DD-YYYY');

      this.project.published = {
        year: published.year(),
        month: published.month()+1,
        day: published.date()
      };
    }
  }

  save() {
    this.submitted = true;

    if (this.project.status === 'subject') {
      if (this.projectForm.invalid) return;
      this.project.sticker = this.stiker;
    }

    if (this.project.published) {
      this.project.published_date = `${this.project.published.year}-${this.project.published.month}-${this.project.published.day}`;
    }

    this.submitted = false;
    this.project.sticker = this.stiker;
    if(!this.project.sticker.description){
      this.project.sticker.description = "";
    }
    if(!this.project.sticker.magazine){
      this.project.sticker.magazine = "";
    }
    if(this.project.status != 'presenting'){
      this.project.presenting_status = null; 
    }

    this.projectSave = Object.assign({}, this.project);
    let forecast_date = this.project.forecast_date.split('-');
    this.projectSave.forecast_date = `${forecast_date[2]}-${forecast_date[0]}-${forecast_date[1]}`
    console.log(this.projectSave);
    this.projectService.update(this.project.id, this.projectSave).
      subscribe(() => {
        this.toast.success(Message.SUCCESS);
        this.activeModal.dismiss();
      });
  }
}
